// extracted by mini-css-extract-plugin
module.exports = {"sticky":"styles_sticky__39REy"};